import { CDN_URL_ICONS, CDN_URL_IMAGES } from '@/configs';
import { Grid } from '@chakra-ui/react';
import { HTMLAttributeAnchorTarget } from 'react';
import s from './style.module.scss';

interface IProps {
  heading?: string;
  subTitle?: string;
  className?: string;
  isContain?: boolean;
  titleLink?: string;
  link?: string;
  target?: HTMLAttributeAnchorTarget | undefined;
  id: string;
  imgUrl: string;
}
export const ColumnContent = ({
  subTitle,
  heading,
  className,
  id,
  imgUrl,
  titleLink,
  link,
  target,
}: IProps): JSX.Element => {
  return (
    <a
      id={id}
      className={`${s.rowContent} ${className}`}
      target={target}
      href={link}
    >
      <div className={s.wrapContent}>
        <div className={`${s.rowContent_left}`}>
          <img src={imgUrl} alt={'Rectangle%203462' + id} />
        </div>
        <div className={` ${s.rowContent_right}`}>
          <div className={s.content}>
            <div className={s.row}>
              <img alt="small-nbc" src={`${CDN_URL_IMAGES}/small_nbc_03.svg`} />
              {heading && <p className={s.title}>{heading}</p>}
            </div>
            {subTitle && <p className={s.desc}>{subTitle}</p>}
            {titleLink && link && (
              <a className={s.wrap_link}>
                <p>{titleLink}</p>
              </a>
            )}
          </div>
        </div>
      </div>
    </a>
  );
};
